/* eslint-disable no-param-reassign */
import Logs from '@/lib/logs';

// 上报事件触发时机对应的注册函数
const EVENTS = {
    click: 'click',
    hover: 'mouseenter',
};

// listener 事件名
const LISTENER = Symbol('bi_listener');

/**
 * @description 埋点上报接口，可以单独使用
 * @param {Record<'web_pageid' | 'web_buttonid' | 'web_ext_json' | 'web_userid', string>} logs 上报信息
 */
export const eventTracking = logs => {
    Logs.imgLog_Button(logs);
};

/**
 * @description 上报指令，arg 参数不传时，默认 click 触发
 */
const bi = {
    inserted(el, binding) {
        const { arg: method = 'click', value } = binding;
        let listener = null;

        // 处理上报时机（比如 click，hover 等才进行上报）
        if (method === 'click') {
            listener = () => eventTracking(value);
            el.addEventListener(EVENTS[method], listener, false);
        }

        // 将事件处理函数添加为 el 的属性，以便 unbind 的时候进行卸载
        if (listener) {
            el[LISTENER] = listener;
        }
    },
    unbind(el, binding) {
        el.removeEventListener(EVENTS[binding.arg], el[LISTENER]);
    },
};

export default bi;
